import React, { useEffect, useState } from 'react';
import { Tree } from 'antd';
import type { DataNode } from 'antd/es/tree';

import { DownOutlined, RightOutlined } from '@ant-design/icons';
import clsx from 'clsx';
import styles from './index.module.scss';
import { CategoryAndSubCategory, useCategory } from '../../../../../store/category';
import { IconArrowShewron } from '../../../../Common/Icon';
import { PostListParams } from '../../../../../store/post/list';

export interface CategoryFilterProps {
  setFilter: React.Dispatch<React.SetStateAction<Partial<PostListParams>>>;
  reset: boolean;
}

export default function CategoryFilter({ reset, setFilter }: CategoryFilterProps): React.ReactElement {
  const [treeData, setTreeData] = useState<DataNode[]>([]);
  const [selectedCategoryId, setSelectedCategoryId] = useState<string | null>(null);
  const [selectedSubCategoryId, setSelectedSubCategoryId] = useState<string | null>(null);

  const { listAll } = useCategory();
  const getCategories = listAll.response?.data;

  useEffect(() => {
    if (reset) {
      setSelectedCategoryId(null);
      setSelectedSubCategoryId(null);
      setExpandedKeys([]); // свернуть дерево
    }
  }, [reset]);

  const [expandedKeys, setExpandedKeys] = useState<React.Key[]>([]);

  useEffect(() => {
    if (selectedCategoryId && selectedSubCategoryId) {
      setFilter((prev) => ({
        ...prev,
        categoryId: selectedCategoryId,
        subCategoryId: selectedSubCategoryId,
      }));
    }
  }, [selectedCategoryId, selectedSubCategoryId]);

  const convertToTreeData = (categories: CategoryAndSubCategory[]): DataNode[] => categories.map((category) => ({
    key: category.id,
    title: (
      <span className={styles.category}>
        {category.file && <img src={category.file.location} alt="icon" />}
        {category.name}
      </span>
    ),
    children: category.subCategories.map((sub) => ({
      key: sub.id,
      title: sub.header,
    })),
  }));

  useEffect(() => {
    setTreeData(convertToTreeData(getCategories || []));
  }, [getCategories]);

  const onSelect = (keys: React.Key[]) => {
    const selectedKey = keys[0];

    let categoryId = null;
    let subCategoryId = null;

    getCategories?.forEach((cat) => {
      if (cat.id === selectedKey) {
        categoryId = cat.id;
      } else {
        const foundSub = cat.subCategories.find((sub) => sub.id === selectedKey);

        if (foundSub) {
          categoryId = cat.id;
          subCategoryId = foundSub.id;
        }
      }
    });

    setSelectedCategoryId(categoryId);
    setSelectedSubCategoryId(subCategoryId);
  };

  return (
    <div className={styles.treeWrapper}>
      <h5 style={{ marginBottom: 20, color: '#00000066' }}>Select Category:</h5>
      <Tree
        treeData={treeData}
        selectedKeys={[selectedSubCategoryId || selectedCategoryId].filter(Boolean) as React.Key[]}
        expandedKeys={expandedKeys}
        onExpand={(keys) => setExpandedKeys(keys)}
        onSelect={onSelect}
        // eslint-disable-next-line react/no-unstable-nested-components
        switcherIcon={({ expanded }) => (
          <IconArrowShewron
            style={{
              transform: expanded ? 'rotate(360deg)' : 'rotate(180deg)',
              transition: 'transform 0.3s ease',
              marginLeft: 'auto',
            }}
          />
        )}
      />
    </div>
  );
}
